import {
  CONFIRMED_CREATE_POST_ACTION,
  CONFIRMED_DELETE_POST_ACTION,
  CONFIRMED_EDIT_POST_ACTION,
  CONFIRMED_GET_POSTS,
  CREATE_POST_ACTION
} from '../actions/PostTypes';
import { NAVTOGGLE } from '../actions/AuthActions';

const initialState = {
  posts: []
};
function PostsReducer(state = initialState, actions) {
  if (actions.type === CREATE_POST_ACTION) {
    const post = {
      id: Math.random(),
      title: 'Post Title 2asdasd',
      description: 'Sample Description 2asdasdas'
    };

    const posts = [...state.posts];
    posts.push(post);
    return {
      ...state,
      posts
    };
  }

  if (actions.type === CONFIRMED_DELETE_POST_ACTION) {
    const posts = [...state.posts];
    const postIndex = posts.findIndex((post) => post.id === actions.payload);

    posts.splice(postIndex, 1);

    return {
      ...state,
      posts
    };
  }

  if (actions.type === CONFIRMED_EDIT_POST_ACTION) {
    const posts = [...state.posts];
    const postIndex = posts.findIndex((post) => post.id === actions.payload.id);

    posts[postIndex] = actions.payload;
    return {
      ...state,
      posts
    };
  }

  if (actions.type === CONFIRMED_CREATE_POST_ACTION) {
    const posts = [...state.posts];
    posts.push(actions.payload);

    return {
      ...state,
      posts
    };
  }

  if (actions.type === CONFIRMED_GET_POSTS) {
    return {
      ...state,
      posts: actions.payload
    };
  }
  return state;
}

// true  = sidebar is COLLAPSED (menu-toggle class = sidebar hidden/icon-only in this template)
// false = sidebar is EXPANDED (default desktop view)
function toggleMenu(state = true, action) {
  if (action.type === NAVTOGGLE) {
    return !state;
  }
  // Allow directly setting the sidebar state (e.g. on resize)
  if (action.type === 'SIDEBAR_SET') {
    return action.payload;
  }
  return state;
}

export { toggleMenu };
export default PostsReducer;
